/* Nav glyphs that a page also puts in its own header.

   The sidebar draws its icons inline (see `NAV_ICONS` in `Container.js`) so
   they inherit `currentColor`. Where a page shows the same icon at the top of
   its content, the paths live here instead of being copied into both files —
   otherwise the two drift apart and the page ends up wearing a different
   symbol than the nav row that leads to it.

   Each export is the bare shape set, to be dropped inside a
   `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor">`. */

/* Four tiles — the connected-tools grid. */
export const TOOLS_GLYPH = (
  <>
    <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" />
    <rect x="13.5" y="3.5" width="7" height="7" rx="1.8" />
    <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" />
    <rect x="13.5" y="13.5" width="7" height="7" rx="1.8" />
  </>
);

/* A directory tree — one node branching to two. */
export const DIRECTORY_GLYPH = (
  <>
    <rect x="9" y="3" width="6" height="5" rx="1.5" />
    <rect x="3" y="16" width="6" height="5" rx="1.5" />
    <rect x="15" y="16" width="6" height="5" rx="1.5" />
    <path d="M12 8v3.5" />
    <path d="M6 16v-2.5h12V16" />
  </>
);

/* The sign-in screen itself: a browser frame with the account card inside it.
   The door-and-arrow this replaced is the sign-out glyph — the same one the
   account menu uses — so the two read as the same action. */
export const LOGIN_PAGE_GLYPH = (
  <>
    <rect x="2.5" y="3.5" width="19" height="17" rx="2.5" />
    <path d="M2.5 8.25h19" />
    <path d="M5.5 5.9h.01M8 5.9h.01" />
    <circle cx="12" cy="12.6" r="2" />
    <path d="M8.5 18a3.7 3.7 0 0 1 7 0" />
  </>
);

/* A licence card with a seal below it. */
export const LICENSE_GLYPH = (
  <>
    <rect x="3" y="4" width="18" height="11" rx="2" />
    <path d="M7 8h6M7 11h4" />
    <circle cx="16.5" cy="17.5" r="3" />
    <path d="m14.8 19.8-.5 2.2 2.2-1.1 2.2 1.1-.5-2.2" />
  </>
);
